var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35355 11.6464L4.20711 11.5H4H3C2.17157 11.5 1.5 10.8284 1.5 10V5C1.5 4.17157 2.17157 3.5 3 3.5H12C12.8284 3.5 13.5 4.17157 13.5 5V10C13.5 10.8284 12.8284 11.5 12 11.5H7H6.5V12V13.7929L4.35355 11.6464Z",
    stroke: "#8292AB",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#8292AB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon_comment.eea1add6bcd50818b3b02297f498a5ad.svg";
export { ForwardRef as ReactComponent };